var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SystemIcon } from '@storeblocks/icon';
import InlineAlert from '@storeblocks/inline-alert';
import Hint from '@storeblocks/hint';
import { Popover } from '@storeblocks/popover';
import { SelectBase, Label, Container, NativeSelect } from './styled';
export function Select(_a) {
    var { id, name, label = '', hint = '', placeholder = '', small = false, medium = true, large = false, fluid = false, disabled = false, error = '', options, value, onChange, hintProps = {}, labelProps = {}, inputProps = {}, attentionProps, labelPopoverProps } = _a, props = __rest(_a, ["id", "name", "label", "hint", "placeholder", "small", "medium", "large", "fluid", "disabled", "error", "options", "value", "onChange", "hintProps", "labelProps", "inputProps", "attentionProps", "labelPopoverProps"]);
    const labelId = `${id}-select-label`;
    const errorId = `${id}-select-error`;
    function renderLabel() {
        return (label && (React.createElement(Label, Object.assign({ id: labelId, htmlFor: id }, labelProps),
            label,
            labelPopoverProps && (React.createElement(Popover, Object.assign({}, labelPopoverProps), labelPopoverProps.children)))));
    }
    function renderHint() {
        return hint && React.createElement(Hint, Object.assign({}, hintProps), hint);
    }
    function renderPlaceholder() {
        return (placeholder && (React.createElement("option", { value: "", disabled: true, hidden: true }, placeholder)));
    }
    function renderOptions() {
        return options.map((option) => (React.createElement("option", Object.assign({ key: option.label, value: option.value }, option), option.label)));
    }
    function renderError() {
        if (error && typeof error === 'string') {
            return (React.createElement(InlineAlert, Object.assign({ id: errorId, title: error, variant: "error", "aria-label": `Error - ${error}` }, attentionProps)));
        }
        return null;
    }
    function handleChange(event) {
        const option = options.find(({ value: internal }) => event.target.value === internal);
        onChange(event, option);
    }
    return (React.createElement(SelectBase, Object.assign({ fluid: fluid, "aria-disabled": disabled }, props),
        renderLabel(),
        renderHint(),
        React.createElement(Container, null,
            React.createElement(NativeSelect, Object.assign({ id: id, name: name, small: small, medium: medium, large: large, fluid: fluid, value: value, onChange: (event) => handleChange(event), disabled: disabled, error: error, "aria-invalid": !!error, "aria-describedby": `${labelId} ${errorId}` }, inputProps),
                renderPlaceholder(),
                renderOptions()),
            React.createElement(SystemIcon, { name: "arrow-drop-down", size: 16 })),
        renderError()));
}
export default Select;
